import url from 'url';

function getQueryVariable(query, variable) {
    var query = query.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
            return decodeURIComponent(pair[1]);
        }
    }
}

let warehouse = 'TEST01';
try {
    if (window.location.host.endsWith('noon.team')) {
        warehouse = 'JED01';
    }
    warehouse = getQueryVariable(window.location.search, 'wh') || warehouse;
} catch (e) {}

export function request(
    method = 'GET',
    endpoint,
    param,
    body = {},
    customOptions = {},
) {
    const options = Object.assign(
        {},
        {
            credentials: 'same-origin',
            method: method,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                'X-Warehouse': warehouse,
            },
        },
        customOptions,
    );

    if (method !== 'GET') {
        options.body = JSON.stringify(body);
    }

    let path = url.parse(endpoint);
    path.query = param;

    return fetch(url.format(path), options).then(res => {
        let isJson =
            res.headers.get('content-type').indexOf('application/json') !== -1;
        let type = isJson ? 'json' : 'text';
        let transformed = res[type]();

        if (!res.ok) {
            return transformed.then(res => Promise.reject(res));
        }

        return transformed;
    });
}

const req = {
    get: function(url, params, options) {
        return request('GET', url, params, null, options);
    },
    post: function(url, body, options) {
        return request('POST', url, '', body, options);
    },
};

export default req;



// WEBPACK FOOTER //
// ./src/request.js